import React from "react";
import { Container, H3, P, Content } from "./styles";
import { Spinner } from "../SpinnerLoading";

const Loading: React.FC = ({ ...rest }) => {
  return (
    <Container {...rest}>
      <Content>
        <Spinner />
        <H3>Aguarde uns instantes</H3>
        <P>Estamos te redirecionando</P>
      </Content>
    </Container>
  );
};

export default Loading;
